<template>
    <div class="record">
<!--        <div class="title">-->
<!--            <p class="return" @click="back">-->
<!--                <img src="~@public/img/user/login/jian.png"/>-->
<!--            </p>-->
<!--            出入境记录-->
<!--        </div>-->
        <van-field label="证件类型:" :value="value" placeholder="请选择" readonly is-link @click="showPicker = true"/>
        <van-field label="证件号码:" placeholder="请选择" readonly is-link @click="showPicker2 = true"/>
        <van-cell-group>
            <van-field label="开始时间:" placeholder="请选择" readonly is-link @click="openTime" :value="value3"/>
            <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    v-if="timeShow"
                    @confirm="handleTime"
                    @cancel="closeTime"
            />
        </van-cell-group>

        <van-cell-group>
            <van-field label="结束时间:" placeholder="请选择" readonly is-link @click="openHour" :value="value4"/>
            <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    v-if="hourShow"
                    @confirm="handleHour"
                    @cancel="closeHour"
            />
        </van-cell-group>

        <van-cell-group>
            <van-tabs v-model="active">
                <van-tab title="三个月"></van-tab>
                <van-tab title="一年"></van-tab>
                <van-tab title="五年"></van-tab>
                <van-tab title="十年"></van-tab>
            </van-tabs>
        </van-cell-group>
        <p class="tips">温馨提示: 只支持查询本人近10年内的出入境记录</p>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="query">查询</van-button>
        </div>

    </div>
</template>

<script>
    import {CellGroup, Field, Toast, Button, DatetimePicker, Tab, Tabs} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import {taskApiMap} from "@/api/task";

    export default {
        name: "RecordQuery",
        components: {
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button,
            [DatetimePicker.name]: DatetimePicker,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs
        },
        data() {
            return {
                active: 0,
                value: '',
                value3: '',//开始时间输入框的值
                value4: '',//结束时间输入框的值
                showPicker: false,
                currentDate: new Date(),
                timeShow: false, //开始时间日历显示与隐藏
                hourShow: false //结束时间日历显示与隐藏
            }
        },
        methods: {
            /**
             * 控制开始时间 和结束时间
             */
            handleTime(value1) {
                let year = this.currentDate.getFullYear();
                let month = this.currentDate.getMonth() + 1;
                let day = this.currentDate.getDate();
                value1 = year + '-' + month + '-' + day
                this.value3 = value1
                this.timeShow = false
            },
            closeTime() {
                this.timeShow = false
            },
            onConfirm(value) {
                this.value = value;
                this.showPicker = false;
            },
            openTime() {
                this.timeShow = true
            },
            openHour() {
                this.hourShow = true
            },
            handleHour(value2) {
                let year = this.currentDate.getFullYear();
                let month = this.currentDate.getMonth() + 1;
                let day = this.currentDate.getDate();
                value2 = year + '-' + month + '-' + day
                this.value4 = value2
                this.hourShow = false
            },
            closeHour() {
                this.hourShow = false
            },
            /**
             * 点击查询
             */
            async query() {

            },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>
    .title {
        padding: 20px 10px 10px 10px;
        height: 80px;
        font-size: 32px;
        color: #fff;
        background-color: #1989fa;
        position: relative;
        text-align: center;
    }
    .return img {
        font-size: 40px;
        width: 18px;
        height: 29px;
        position: fixed;
        left: 0.4rem;
        top: 0.35rem;
    }

    .input-div{
        width: 100% !important;
    }

    .tips {
        margin: 1rem 0 0 1rem;
        color: #ccc;
    }


</style>
<style>
   .record .van-tab {
        color: #323233;
    }

   .record .van-tabs {
        margin: 0 0.5rem 0 0.5rem;
    }

   .record .van-tabs__line {
        background-color: transparent;
    }

    .record .van-tab--active {
        color: #fff;
        background-color: #ffb21d;
        border-radius: 0.2rem;
    }
</style>
